var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnit0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2339_2208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.889,
    height: 16,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 249.284,
    cy: 250.715,
    rx: 243.262,
    ry: 243.262
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2339_2208)",
    transform: "matrix(14.718953, 0, 0, 14.718953, 88.032471, 144.249542)",
    style: {}
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 15.111 15.111 L 15.111 8 L 22.222 8 L 22.222 0.889 L 15.111 0.889 L 15.111 8 L 8 8 L 8 0.889 L 0.889 0.889 L 0.889 15.111 L 15.111 15.111 Z",
    fill: "#9FE0C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit0);
export default __webpack_public_path__ + "static/media/UNIT0.869233fb878a6106a3ef1f3f7198029a.svg";
export { ForwardRef as ReactComponent };